// @generated by protoc-gen-es v2.15.0 with parameter "target=ts"
// @generated from file plataforma_seguridad_usuarios_plataforma.proto (package sextante.plataforma.seguridad.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file plataforma_seguridad_usuarios_plataforma.proto.
 */
export const file_plataforma_seguridad_usuarios_plataforma: GenFile = /*@__PURE__*/
  fileDesc("Ci5wbGF0YWZvcm1hX3NlZ3VyaWRhZF91c3Vhcmlvc19wbGF0YWZvcm1hLnByb3RvEiBzZXh0YW50ZS5wbGF0YWZvcm1hLnNlZ3VyaWRhZC52MSIfCh1MaXN0VXN1YXJpb3NQbGF0YWZvcm1hUmVxdWVzdCJoCh5MaXN0VXN1YXJpb3NQbGF0YWZvcm1hUmVzcG9uc2USRgoFaXRlbXMYASADKAsyNy5zZXh0YW50ZS5wbGF0YWZvcm1hLnNlZ3VyaWRhZC52MS5Vc3VhcmlvUGxhdGFmb3JtYUl0ZW0i9gEKFVVzdWFyaW9QbGF0YWZvcm1hSXRlbRIKCgJpZBgBIAEoCRIOCgZub21icmUYAiABKAkSDQoFZW1haWwYAyABKAkSEQoJaXNfYWN0aXZvGAQgASgIEhcKD2hhc19zdXBlcl9hZG1pbhgGIAEoCBIVCg1oYXNfY29tZXJjaWFsGAcgASgIEhQKDGhhc19oYXJkd2FyZRgIIAEoCBITCgtoYXNfcGlsb3RvcxgJIAEoCBIXCg9oYXNfY29uZHVjdG9yZXMYCiABKAgSEwoLaGFzX29maWNpbmEYCyABKAhKBAgFEAZSEGlzX3N1cGVyX3VzdWFyaW8isAIKH0d1YXJkYXJVc3VhcmlvUGxhdGFmb3JtYVJlcXVlc3QSDwoCaWQYASABKAlIAIgBARIOCgZub21icmUYAiABKAkSDQoFZW1haWwYAyABKAkSFQoIcGFzc3dvcmQYBCABKAlIAYgBARIRCglpc19hY3Rpdm8YBSABKAgSFwoPaGFzX3N1cGVyX2FkbWluGAcgASgIEhUKDWhhc19jb21lcmNpYWwYCCABKAgSFAoMaGFzX2hhcmR3YXJlGAkgASgIEhMKC2hhc19waWxvdG9zGAogASgIEhcKD2hhc19jb25kdWN0b3JlcxgLIAEoCBITCgtoYXNfb2ZpY2luYRgMIAEoCEIFCgNfaWRCCwoJX3Bhc3N3b3JkSgQIBhAHUhBpc19zdXBlcl91c3VhcmlvIigKGlVzdWFyaW9QbGF0YWZvcm1hSWRSZXF1ZXN0EgoKAmlkGAEgASgJIiEKH1VzdWFyaW9QbGF0YWZvcm1hQWNjaW9uUmVzcG9uc2UyxQMKGVVzdWFyaW9zUGxhdGFmb3JtYVNlcnZpY2USkQEKDExpc3RVc3VhcmlvcxI/LnNleHRhbnRlLnBsYXRhZm9ybWEuc2VndXJpZGFkLnYxLkxpc3RVc3Vhcmlvc1BsYXRhZm9ybWFSZXF1ZXN0GkAuc2V4dGFudGUucGxhdGFmb3JtYS5zZWd1cmlkYWQudjEuTGlzdFVzdWFyaW9zUGxhdGFmb3JtYVJlc3BvbnNlEoUBCgdHdWFyZGFyEkEuc2V4dGFudGUucGxhdGFmb3JtYS5zZWd1cmlkYWQudjEuR3VhcmRhclVzdWFyaW9QbGF0YWZvcm1hUmVxdWVzdBo3LnNleHRhbnRlLnBsYXRhZm9ybWEuc2VndXJpZGFkLnYxLlVzdWFyaW9QbGF0YWZvcm1hSXRlbRKLAQoIRWxpbWluYXISPC5zZXh0YW50ZS5wbGF0YWZvcm1hLnNlZ3VyaWRhZC52MS5Vc3VhcmlvUGxhdGFmb3JtYUlkUmVxdWVzdBpBLnNleHRhbnRlLnBsYXRhZm9ybWEuc2VndXJpZGFkLnYxLlVzdWFyaW9QbGF0YWZvcm1hQWNjaW9uUmVzcG9uc2VCFqoCE0FwaS5HcnBjLlBsYXRhZm9ybWFiBnByb3RvMw");

/**
 * Sin parametros.
 *
 * @generated from message sextante.plataforma.seguridad.v1.ListUsuariosPlataformaRequest
 */
export type ListUsuariosPlataformaRequest = Message<"sextante.plataforma.seguridad.v1.ListUsuariosPlataformaRequest"> & {
};

/**
 * Describes the message sextante.plataforma.seguridad.v1.ListUsuariosPlataformaRequest.
 * Use `create(ListUsuariosPlataformaRequestSchema)` to create a new message.
 */
export const ListUsuariosPlataformaRequestSchema: GenMessage<ListUsuariosPlataformaRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_seguridad_usuarios_plataforma, 0);

/**
 * Usuarios no eliminados, por nombre, sin los superusuarios.
 *
 * @generated from message sextante.plataforma.seguridad.v1.ListUsuariosPlataformaResponse
 */
export type ListUsuariosPlataformaResponse = Message<"sextante.plataforma.seguridad.v1.ListUsuariosPlataformaResponse"> & {
  /**
   * @generated from field: repeated sextante.plataforma.seguridad.v1.UsuarioPlataformaItem items = 1;
   */
  items: UsuarioPlataformaItem[];
};

/**
 * Describes the message sextante.plataforma.seguridad.v1.ListUsuariosPlataformaResponse.
 * Use `create(ListUsuariosPlataformaResponseSchema)` to create a new message.
 */
export const ListUsuariosPlataformaResponseSchema: GenMessage<ListUsuariosPlataformaResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_seguridad_usuarios_plataforma, 1);

/**
 * Usuario de Plataforma con sus roles.
 *
 * @generated from message sextante.plataforma.seguridad.v1.UsuarioPlataformaItem
 */
export type UsuarioPlataformaItem = Message<"sextante.plataforma.seguridad.v1.UsuarioPlataformaItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string nombre = 2;
   */
  nombre: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * @generated from field: bool is_activo = 4;
   */
  isActivo: boolean;

  /**
   * Rol administrador.
   *
   * @generated from field: bool has_super_admin = 6;
   */
  hasSuperAdmin: boolean;

  /**
   * @generated from field: bool has_comercial = 7;
   */
  hasComercial: boolean;

  /**
   * Rol Soporte de la pantalla de usuarios.
   *
   * @generated from field: bool has_hardware = 8;
   */
  hasHardware: boolean;

  /**
   * Rol Piloto / Conductor: flota y vuelos.
   *
   * @generated from field: bool has_pilotos = 9;
   */
  hasPilotos: boolean;

  /**
   * Rol Piloto / Conductor: flota y vuelos.
   *
   * @generated from field: bool has_conductores = 10;
   */
  hasConductores: boolean;

  /**
   * @generated from field: bool has_oficina = 11;
   */
  hasOficina: boolean;
};

/**
 * Describes the message sextante.plataforma.seguridad.v1.UsuarioPlataformaItem.
 * Use `create(UsuarioPlataformaItemSchema)` to create a new message.
 */
export const UsuarioPlataformaItemSchema: GenMessage<UsuarioPlataformaItem> = /*@__PURE__*/
  messageDesc(file_plataforma_seguridad_usuarios_plataforma, 2);

/**
 * Usuario a crear o editar, con sus roles. En Nitrofert solo se leen el id y los roles.
 *
 * @generated from message sextante.plataforma.seguridad.v1.GuardarUsuarioPlataformaRequest
 */
export type GuardarUsuarioPlataformaRequest = Message<"sextante.plataforma.seguridad.v1.GuardarUsuarioPlataformaRequest"> & {
  /**
   * @generated from field: optional string id = 1;
   */
  id?: string | undefined;

  /**
   * @generated from field: string nombre = 2;
   */
  nombre: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * Al crear: ausente = aleatoria. Al editar: ausente = no cambia.
   *
   * @generated from field: optional string password = 4;
   */
  password?: string | undefined;

  /**
   * @generated from field: bool is_activo = 5;
   */
  isActivo: boolean;

  /**
   * @generated from field: bool has_super_admin = 7;
   */
  hasSuperAdmin: boolean;

  /**
   * @generated from field: bool has_comercial = 8;
   */
  hasComercial: boolean;

  /**
   * @generated from field: bool has_hardware = 9;
   */
  hasHardware: boolean;

  /**
   * @generated from field: bool has_pilotos = 10;
   */
  hasPilotos: boolean;

  /**
   * @generated from field: bool has_conductores = 11;
   */
  hasConductores: boolean;

  /**
   * @generated from field: bool has_oficina = 12;
   */
  hasOficina: boolean;
};

/**
 * Describes the message sextante.plataforma.seguridad.v1.GuardarUsuarioPlataformaRequest.
 * Use `create(GuardarUsuarioPlataformaRequestSchema)` to create a new message.
 */
export const GuardarUsuarioPlataformaRequestSchema: GenMessage<GuardarUsuarioPlataformaRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_seguridad_usuarios_plataforma, 3);

/**
 * Usuario sobre el que se actua.
 *
 * @generated from message sextante.plataforma.seguridad.v1.UsuarioPlataformaIdRequest
 */
export type UsuarioPlataformaIdRequest = Message<"sextante.plataforma.seguridad.v1.UsuarioPlataformaIdRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message sextante.plataforma.seguridad.v1.UsuarioPlataformaIdRequest.
 * Use `create(UsuarioPlataformaIdRequestSchema)` to create a new message.
 */
export const UsuarioPlataformaIdRequestSchema: GenMessage<UsuarioPlataformaIdRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_seguridad_usuarios_plataforma, 4);

/**
 * Sin datos: que el rpc no falle ya indica que se hizo.
 *
 * @generated from message sextante.plataforma.seguridad.v1.UsuarioPlataformaAccionResponse
 */
export type UsuarioPlataformaAccionResponse = Message<"sextante.plataforma.seguridad.v1.UsuarioPlataformaAccionResponse"> & {
};

/**
 * Describes the message sextante.plataforma.seguridad.v1.UsuarioPlataformaAccionResponse.
 * Use `create(UsuarioPlataformaAccionResponseSchema)` to create a new message.
 */
export const UsuarioPlataformaAccionResponseSchema: GenMessage<UsuarioPlataformaAccionResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_seguridad_usuarios_plataforma, 5);

/**
 * Usuarios de la app Plataforma (menu Usuarios). Migracion a gRPC-Web con logica propia (ver CLAUDE.md).
 * Inactivar, cambiar la contrasena o eliminar cierran las sesiones abiertas del usuario. Requiere sesion de
 * Plataforma. Los superusuarios no existen para este servicio (2026-10-14): no salen en la lista, no se editan ni
 * se eliminan, y la marca de superusuario no se envia ni se recibe. En Nitrofert solo se gestionan roles.
 *
 * @generated from service sextante.plataforma.seguridad.v1.UsuariosPlataformaService
 */
export const UsuariosPlataformaService: GenService<{
  /**
   * Usuarios no eliminados, por nombre, sin los superusuarios.
   *
   * @generated from rpc sextante.plataforma.seguridad.v1.UsuariosPlataformaService.ListUsuarios
   */
  listUsuarios: {
    methodKind: "unary";
    input: typeof ListUsuariosPlataformaRequestSchema;
    output: typeof ListUsuariosPlataformaResponseSchema;
  },
  /**
   * Alta (contrasena elegida o aleatoria, enviada por correo) o edicion. En Nitrofert no se crea
   * (FailedPrecondition) y al editar solo se guardan los roles.
   *
   * @generated from rpc sextante.plataforma.seguridad.v1.UsuariosPlataformaService.Guardar
   */
  guardar: {
    methodKind: "unary";
    input: typeof GuardarUsuarioPlataformaRequestSchema;
    output: typeof UsuarioPlataformaItemSchema;
  },
  /**
   * Baja logica y cierre de sesiones. Idempotente. En Nitrofert no se permite (FailedPrecondition).
   *
   * @generated from rpc sextante.plataforma.seguridad.v1.UsuariosPlataformaService.Eliminar
   */
  eliminar: {
    methodKind: "unary";
    input: typeof UsuarioPlataformaIdRequestSchema;
    output: typeof UsuarioPlataformaAccionResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_plataforma_seguridad_usuarios_plataforma, 0);

